// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__A1XHg","right":"styles_right__3xL1O"};